// Central interface text (Slovak). Kept separate from logic so Czech / English can be added later.
export const t = {
  brand: "RareCandy",
  brandFull: "RareCandy.sk",
  announcement: "Doprava ZADARMO nad 75 € · Vzácne Pokémon TCG úlovky a najnovšie série",
  nav: {
    home: "Domov",
    series: "Pokémon série",
    etb: "ETB boxy",
    boosters: "Boostre",
    cards: "Jednotlivé karty",
    contact: "Kontakt",
  },
  actions: {
    search: "Hľadať",
    searchPlaceholder: "Hľadaj série, produkty, karty...",
    cart: "Košík",
    addToCart: "Pridať do košíka",
    added: "Pridané do košíka",
    explore: "Objaviť kolekciu",
    viewNews: "Čerstvé úlovky",
    viewProduct: "Zobraziť produkt",
    viewAll: "Zobraziť všetko",
    checkout: "Pokračovať k pokladni",
    continueShopping: "Pokračovať v nákupe",
    remove: "Odstrániť",
    language: "Jazyk",
  },
  hero: {
    eyebrow: "Zberateľské Pokémon TCG · Slovensko",
    headline: "Každý balíček ukrýva niečo vzácne.",
    sub: "Objav najnovšie Pokémon TCG série a nájdi svoj ďalší zberateľský poklad.",
  },
  categories: {
    title: "Tri cesty k pokladu",
    subtitle: "Prehľadávaj podľa typu produktu naprieč všetkými sériami.",
  },
  seriesHighlight: {
    eyebrow: "Série",
    title: "Najzaujímavejšie Pokémon TCG série",
    subtitle: "Od éry Scarlet & Violet až po novú éru Mega Evolution.",
  },
  featured: {
    eyebrow: "RareCandy výber",
    title: "Odporúčané produkty",
    subtitle: "Ručne vybrané kúsky, ktoré stoja za pozornosť.",
  },
  newArrivals: {
    eyebrow: "Novinky",
    title: "Čerstvé úlovky",
    subtitle: "Najnovšie prírastky do našej ponuky.",
  },
  cardsSection: {
    title: "Poklady do zbierky",
  },
  brandIntro: {
    eyebrow: "O RareCandy",
    title: "Vzácne úlovky pre zberateľov",
    body: "RareCandy.sk je prémiový slovenský obchod zameraný na autentické Pokémon TCG produkty — ETB boxy, boostre aj jednotlivé zberateľské karty. Sústredíme sa na pravosť, starostlivé balenie a objavovanie nových sérií, aby každý nákup pôsobil ako skutočný úlovok.",
  },
  trust: {
    title: "Prečo RareCandy",
    items: [
      { title: "Autentické produkty", desc: "Ponúkame výhradne originálne Pokémon TCG produkty. Žiadne napodobeniny." },
      { title: "Starostlivé balenie", desc: "Zberateľské produkty balíme spevnene s ochranou proti poškodeniu rohov." },
      { title: "Objavovanie sérií", desc: "Sledujeme nové série éry Mega Evolution aj overené klasiky." },
      { title: "Zákaznícka podpora", desc: "Slovenská podpora a férové riešenie prípadných reklamácií." },
    ],
  },
  product: {
    expansion: "Séria",
    availability: "Dostupnosť",
    quantity: "Množstvo",
    description: "Popis",
    related: "Ďalšie z tejto série",
    illustrative: "Ilustračné foto",
    specs: "Parametre",
    type: "Typ produktu",
    cardNumber: "Číslo karty",
    rarity: "Rarita",
    cardLanguage: "Jazyk karty",
    condition: "Stav",
    priceOnRequest: "Cena na vyžiadanie",
  },
  availability: {
    in_stock: "Na sklade",
    low_stock: "Posledné kusy",
    preorder: "Predobjednávka / čoskoro",
    sold_out: "Vypredané",
  },
  productTypes: {
    etb: "ETB boxy",
    booster_box: "Booster boxy",
    booster_pack: "Booster packy",
  },
  cart: {
    title: "Nákupný košík",
    empty: "Tvoj košík je prázdny.",
    subtotal: "Medzisúčet",
    shipping: "Doprava",
    total: "Spolu",
    freeShipping: "Doprava zadarmo!",
    freeShippingRemain: (amount) => `Do dopravy zadarmo zostáva ${amount}`,
    checkoutDisabledTitle: "Objednávanie ešte nie je spustené",
    adjustedNote: "Množstvo bolo upravené podľa dostupnosti skladu.",
    goToCheckout: "Prejsť k pokladni",
  },
  checkout: {
    title: "Pokladňa",
    eyebrow: "Dokončenie objednávky",
    intro: "Vyplň doručovacie údaje a zaplať kartou cez zabezpečenú bránu Stripe.",
    contact: "Kontaktné údaje",
    delivery: "Doručovacia adresa",
    fullName: "Meno a priezvisko",
    email: "E-mail",
    phone: "Telefón",
    address: "Ulica a číslo",
    city: "Mesto",
    zip: "PSČ",
    country: "Krajina",
    note: "Poznámka k objednávke (nepovinné)",
    summary: "Zhrnutie objednávky",
    terms: "Súhlasím s obchodnými podmienkami a spracovaním osobných údajov.",
    pay: "Zaplatiť kartou",
    paying: "Presmerúvam na platbu…",
    empty: "Košík je prázdny — pred pokladňou pridaj produkty.",
    backToShop: "Späť do obchodu",
    required: "Povinné pole",
    securePay: "Zabezpečená platba cez Stripe",
  },
  payment: {
    successTitle: "Ďakujeme za objednávku!",
    successDesc: "Platba prebehla úspešne. Potvrdenie a detaily objednávky sme zaznamenali.",
    orderNumber: "Číslo objednávky",
    checking: "Overujem stav platby…",
    failedTitle: "Platba nebola dokončená",
    failedDesc: "Platba sa nepodarila alebo bola zrušená. Skús to prosím znova.",
    cancelTitle: "Platba zrušená",
    cancelDesc: "Platbu si zrušil. Tvoj košík zostal zachovaný, môžeš to skúsiť znova.",
    continueShopping: "Pokračovať v nákupe",
    backToCart: "Späť do košíka",
    total: "Zaplatená suma",
  },
  footer: {
    tagline: "Prémiový slovenský obchod s autentickými Pokémon TCG produktmi. Vzácne úlovky a najnovšie série.",
    shop: "Nákup",
    info: "Informácie",
    contact: "Kontakt",
    policies: {
      shipping: "Doprava a platba",
      returns: "Vrátenie tovaru",
      terms: "Obchodné podmienky",
      privacy: "Ochrana osobných údajov",
    },
    disclaimer: "Nezávislý predajca. Nie sme oficiálne spojení ani endorsovaní spoločnosťou The Pokémon Company. Pokémon a Pokémon TCG sú ochranné známky príslušných vlastníkov.",
    rights: "Všetky práva vyhradené.",
  },
  catalog: {
    filters: "Filtre",
    sort: "Zoradiť",
    allSeries: "Všetky série",
    allTypes: "Všetky typy",
    results: (n) => `${n} položiek`,
    noResults: "Nenašli sa žiadne položky.",
    noCards: "Momentálne tu nie sú žiadne jednotlivé karty.",
    searchTitle: (q) => `Výsledky pre „${q}“`,
  },
};

export const formatEur = (value) =>
  new Intl.NumberFormat('sk-SK', { style: 'currency', currency: 'EUR' }).format(value);
